import React from "react"
import type { ReactNode } from "react"
import VisuallyHidden from "../visually-hidden"
import { OldButton } from "."
import cx from "classnames"
import type { OldButtonProps } from "."

const SIZES = {
  sm: "w-8",
  md: "w-10",
  lg: "w-12"
}

export type OldIconButtonBaseProps = {
  /** Accessibility label for the button */
  label: string
  /** Size of the icon button */
  size?: keyof typeof SIZES
  /** Additional CSS classes */
  className?: string
  /** The icon element to render */
  children: ReactNode
} & Omit<OldButtonProps, "icon" | "children">

const OldIconButtonBase = React.forwardRef<
  HTMLButtonElement | HTMLAnchorElement,
  OldIconButtonBaseProps
>(({ label, size = "md", children, className, ...props }, ref) => {
  return (
    <OldButton
      {...props}
      size={size}
      className={cx(SIZES[size], className)}
      ref={ref}
    >
      <VisuallyHidden>{label}</VisuallyHidden>
      {children}
    </OldButton>
  )
})

export { OldIconButtonBase }
